import { Col, Row } from 'antd'
import React from 'react'
import Banner from '../../components/banner'
import Marquee from '../../components/marquee'
import TopGame from '../../components/top_game'
import RecentGame from '../../components/recent_game'

export default function HomePage({bannerInfo}) {
  return (
    <Row gutter={[16, 16]}> 
      <Col span={24}>
        <Banner bannerInfo = {bannerInfo} />
      </Col>
      <Col span={24}>
        <Marquee />
      </Col>
      <Col span={24}>
        <TopGame  />
      </Col>
      <Col span={24}>
        <RecentGame  />
      </Col>
    </Row>
  )
}
